<template>
	<van-uploader :name="id" :after-read="previewImg" class="upload-img__box">
		<div class="upload-file">
			<img class="upload-file__img" v-if="imgsrc" :src="imgsrc"/>
			<img class="upload-file__img" v-if="!imgsrc && img" :src="img"/>
			<i class="iconfont">&#xef31;</i>
		</div>
	</van-uploader>
</template>
<script>
import Vue from 'vue'
import {Toast} from 'vant'
Vue.use(Toast)
import MFileUploader from '@/assets/scripts/upload';
export default {
	name: 'UploadFile',
	data(){
		return {
			imgsrc:'', // 上传后的图片预览地址
			fileUploader:{},	// 上传OSS的操作对象
			imgbase64: ''	// 上传后图片的base64代码，快速预览
		}
	},
	props: {
		id: {	// 唯一id
			type: String,
			required: true
		},
		mod: {	// 方式
			type: String,
			default: ''
		},
		img:{
			type: String,
			default: ''
		}
	},
	mounted() {
		this.bindEventUpload();
	},
	methods: {
		previewImg: function(file){
			if(!this.mod){
				this.imgsrc = file.content;
			}else{
				this.imgbase64 = file.content
			}
		},
		bindEventUpload: function(){
			// 绑定上传事件
			let thisid = this.id;
            let _this = this;
            _this.fileUploader = new MFileUploader({
				fileEl:document.getElementsByName(thisid)[0]
			});
            this.fileUploader.onFileSelect = function(file){
				// console.log(_this.fileUploader)
        		// return;
				Toast.loading({
					mask: true,
					forbidClick: true,
					duration: 0,
					message: '上传中...'
				});
				_this.getSig(file.name).then(data => {
					_this.uploadOss(data);
				}).catch(e => {
					console.error('upload error', e);
				});
            };
            this.fileUploader.onFileUpLoaded = function(data) {
				Toast.clear();
            }
		},
		getSig(fileName) {
			return this.$http.post('upload/getUploadAuth', {
				fileName: fileName
			}).then(data => {
				return data;
			});
		},
		uploadOss(data) {
			this.imgUrl = data.data.value.host_cname + '/' + data.data.value.dir + data.data.value.key+'?x-oss-process=image/resize,m_fill,w_150,h_150,limit_0/auto-orient,0/quality,q_90';
			this.$emit('callBackImgUrl',{
				name: this.id,
				url: this.imgUrl,
				mod: this.mod,
				base64: this.imgbase64
			})

			this.fileUploader.action = data.data.value.host;
			// 上传 oss 的参数
			this.fileUploader.clearFormData();
			this.fileUploader.formData.append('policy', data.data.value.policy);
			this.fileUploader.formData.append('OSSAccessKeyId', data.data.value.accessid);
			this.fileUploader.formData.append('success_action_status', '200');
			this.fileUploader.formData.append('callback', data.data.value.callback);
			this.fileUploader.formData.append('signature', data.data.value.signature);
			this.fileUploader.formData.append('key', data.data.value.dir + data.data.value.key);

			this.fileUploader.upload();
		},
	}
}
</script>
<style lang="less">
.upload-img{
	&__box{
		width: 80%;
        height: 1rem; line-height: 1rem;
	}
}
.upload-file{
	width: 100%; height: 100%;
	border:.01rem dashed #ddd;
	border-radius: .04rem;
	overflow: hidden;
	&>.iconfont{
		font-size: .3rem;
		color:#ddd;
	}
	&__img{
		object-fit: cover;
		width: 100%; height: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/UploadFile.vue